import { WAIT_FILT, WAIT_GET, WAIT_HISTO } from "../actions/action-types";
import { initialStateDatasArray } from "../helpers";

// Obtenir les temps d'attente actuels
export function GetWaitimeReducer(state = initialStateDatasArray, action) {
    switch (action.type) {
        case WAIT_GET:
            return {
                alert: action.payload.alert,
                datas: action.payload.datas
            }
        default:
            return state;
    }
}

// Obtenir les temps d'attente historique
export function GetWaitimeHistoReducer(state = initialStateDatasArray, action) {
    switch (action.type) {
        case WAIT_HISTO:
            return {
                alert: action.payload.alert,
                datas: action.payload.datas
            }
        default:
            return state;
    }
}

// Obtenir les filtres des temps d'attente
export function GetWaitimeFiltersReducer(state = initialStateDatasArray, action) {
    switch (action.type) {
        case WAIT_FILT:
            return {
                alert: action.payload.alert,
                datas: action.payload.datas
            }
        default:
            return state;
    }
}